import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
}), 'ImportExportSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ImportExportSharp.js
// module id = 4228
// module chunks = 2